/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to true to use Lottie animation
};

const greeting = {
  username: "Trisha Karani",
  title: "Hi all, I'm Trisha",
  subTitle: emoji(
    "🧠 A passionate AI/ML Engineer 🧬 with a background in Computer Science and Biomedical Engineering, experienced in building intelligent systems for biotech and healthcare data using Python, PyTorch, and cutting-edge ML frameworks."
  ),
  resumeLink:
    "/resume.pdf", // Link to Trisha's resume
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/tkarani1",
  linkedin: "https://www.linkedin.com/in/trishakarani/",
  gmail: "trisha.karani@example.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE AI/ML ENGINEER WHO LOVES BUILDING INTELLIGENT SYSTEMS FOR BIOTECH & HEALTHCARE DATA",
  skills: [
    emoji(
      "⚡ Conduct applied research in AI/ML for biomedical and healthcare challenges"
    ),
    emoji("⚡ Design and evaluate deep learning models with emphasis on rigor and reproducibility"),
    emoji(
      "⚡ Build pipelines for preprocessing, analysis, and visualization of complex biological datasets"
    ),
    emoji(
      "⚡ Explore innovative intersections of computer science, biology, and medicine to drive discovery"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Johns Hopkins University",
      logo: require("./assets/images/johns_hopkins_university_logo.jpeg"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2023 - May 2025",
      desc: "Advanced studies in computer science with a focus on artificial intelligence, machine learning, and computational methods",
      descBullets: [
        "Specialized in deep learning, natural language processing, and precision care medicine applications",
        "Completed advanced coursework in machine learning, deep learning, AI, databases, algorithms, and human-computer interaction"
      ]
    },
    {
      schoolName: "Johns Hopkins University",
      logo: require("./assets/images/johns_hopkins_university_logo.jpeg"),
      subHeader: "Bachelor of Science in Computer Science and Biomedical Engineering",
      duration: "September 2019 - May 2023",
      desc: "Dual degree program combining computer science with biomedical engineering. Graduated magna cum laude with honors.",
      descBullets: [
        "Specialized in biomedical data analysis, software engineering, and computational biology",
        "Completed advanced coursework in probability & statistics, precision care medicine, algorithms, and data science",
        "Led design teams developing biomedical devices (oxygen monitoring device, implantable knee strain sensor) with industry and clinical collaborators",
        "Contributed to research in computational neurophysiology and deep learning for biomedical imaging and genomics"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Frontend Developer",
      company: "Tech Solutions Inc.",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "June 2023 – Present",
      desc: "Developing responsive web applications using React and modern JavaScript frameworks. Focused on creating intuitive user interfaces and optimizing application performance.",
      descBullets: [
        "Built and maintained multiple React applications",
        "Collaborated with design team to implement pixel-perfect UIs",
        "Optimized application performance resulting in 40% faster load times"
      ]
    },
    {
      role: "Web Developer Intern",
      company: "Digital Agency",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2022 – August 2022",
      desc: "Worked on various client projects including e-commerce websites and corporate landing pages. Gained experience in full-stack development and client communication."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Featured Projects",
  subtitle: "SOME OF MY RECENT WORK AND PERSONAL PROJECTS",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "E-Commerce Platform",
      projectDesc: "A full-stack e-commerce application built with React, Node.js, and MongoDB. Features include user authentication, product catalog, shopping cart, and payment integration.",
      footerLink: [
        {
          name: "View Project",
          url: "https://github.com/trishakarani/ecommerce-platform"
        },
        {
          name: "Live Demo",
          url: "https://trisha-ecommerce-demo.vercel.app"
        }
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Task Management App",
      projectDesc: "A collaborative task management application with real-time updates, drag-and-drop functionality, and team collaboration features.",
      footerLink: [
        {
          name: "View Project",
          url: "https://github.com/trishakarani/task-manager"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Some of my notable achievements and certifications in software development !",

  achievementsCards: [
    {
      title: "React Developer Certification",
      subtitle:
        "Completed comprehensive React development course with focus on modern hooks, state management, and best practices.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "React Certification Logo",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://example.com/certificate"
        }
      ]
    },
    {
      title: "JavaScript Algorithms Certification",
      subtitle:
        "Successfully completed advanced JavaScript algorithms and data structures course with 100% completion rate.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "JavaScript Certification Logo",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://example.com/js-certificate"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "/",
      title: "Work In Progress",
      description: "Will post soon"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY KNOWLEDGE AND EXPERIENCES 😅"
  ),

  talks: [
    {
      title: "Introduction to React Hooks",
      subtitle: "Tech Meetup - Local Developer Community",
      slides_url: "https://example.com/react-hooks-slides",
      event_url: "https://example.com/tech-meetup"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT TECHNOLOGY AND DEVELOPMENT",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://example.com/trisha-podcast"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1-555-0123",
  email_address: "trisha.karani@example.com"
};

// Twitter Section

const twitterDetails = {
  userName: "trishakarani", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};

